(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function setIcon(button, isPlaying) {
    button.querySelector('[data-icon-play]').classList.toggle('hidden', isPlaying);
    button.querySelector('[data-icon-pause]').classList.toggle('hidden', !isPlaying);
  }

  // Click on the toggle button: play/pause the media
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-video-toggle]');
    if (!button) return;

    var media = button.closest('deferred-media').querySelector('[data-video-player]');
    if (!media) return;

    if (media.tagName === 'VIDEO') {
      media.paused ? media.play() : media.pause();
    } else if (media.tagName === 'IFRAME' && media.contentWindow) {
      var isPlaying = !button.querySelector('[data-icon-pause]').classList.contains('hidden');
      var command =
        media.dataset.videoType === 'youtube'
          ? { event: 'command', func: isPlaying ? 'pauseVideo' : 'playVideo', args: [] }
          : { method: isPlaying ? 'pause' : 'play' };
      media.contentWindow.postMessage(JSON.stringify(command), '*');
      setIcon(button, !isPlaying);
    }
  });

  // Keep the icon in sync with real play/pause events on <video> elements.
  // Capture phase lets this work for videos added to the page later, with no extra setup.
  ['play', 'pause', 'ended'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        var container = event.target.closest && event.target.closest('deferred-media');
        var button = container && container.querySelector('[data-video-toggle]');
        if (button) setIcon(button, eventName === 'play');
      },
      true
    );
  });
  } catch(e) { console.error(e); }
})();

})();
